import React from 'react';
import { ClusterPageTemplate } from '../components/ClusterPageTemplate';
export function ClusterProjectontwikkelaarPage() {
  return <ClusterPageTemplate clusterName="Projectontwikkelaar" sectorName="Makelaars & Vastgoed" sectorSlug="makelaars-vastgoed" heroTitle="Website laten maken voor projectontwikkelaars" heroDescription="Hoogwaardige websites voor vastgoedontwikkelaars en nieuwbouwprojecten. Wij bouwen platforms die jouw visie digitaal tot leven brengen." websiteOnderdelen={[{
    icon: 'BuildingIcon',
    title: 'Projectportfolio',
    description: 'Een indrukwekkend overzicht van lopende, afgeronde en toekomstige vastgoedprojecten.'
  }, {
    icon: 'HomeIcon',
    title: 'Woningzoeker',
    description: 'Voor specifieke nieuwbouwprojecten: een interactieve kaart of lijst waar geïnteresseerden bouwnummers kunnen bekijken.'
  }, {
    icon: 'UsersIcon',
    title: 'Over de ontwikkelaar',
    description: 'Jullie visie op bouwen, duurzaamheid en de geschiedenis van het bedrijf.'
  }, {
    icon: 'FileTextIcon',
    title: 'Inschrijfmodule',
    description: 'Een veilig systeem waar geïnteresseerden zich kunnen inschrijven voor nieuwsbrieven of specifieke bouwnummers.'
  }]} functionaliteiten={[{
    icon: 'CameraIcon',
    title: 'Visuele presentatie',
    description: "Ondersteuning voor grote renders, 3D-tours, video's en interactieve plattegronden."
  }, {
    icon: 'FileTextIcon',
    title: 'Leadgeneratie',
    description: 'Slimme formulieren om interesse te peilen in vroege fases van een project.'
  }, {
    icon: 'LaptopIcon',
    title: 'CRM Integratie',
    description: 'Koppeling met systemen zoals NieuwbouwOffice om inschrijvingen direct goed te verwerken.'
  }]} siblingClusters={[{
    name: 'Makelaar',
    slug: 'makelaar'
  }, {
    name: 'Vastgoedbeheer',
    slug: 'vastgoedbeheer'
  }, {
    name: 'Woningpresentatie',
    slug: 'woningpresentatie'
  }]} faqs={[{
    q: 'Bouwen jullie ook websites voor één specifiek nieuwbouwproject?',
    a: 'Ja, we bouwen zowel corporate websites voor de ontwikkelaar zelf, als specifieke campagnewebsites voor individuele nieuwbouwprojecten.'
  }, {
    q: 'Kunnen jullie een interactieve kavelkaart inbouwen?',
    a: 'Zeker. We kunnen interactieve kaarten integreren waarop bezoekers kunnen zien welke bouwnummers nog beschikbaar, onder optie of verkocht zijn.'
  }, {
    q: 'Wat kost een website voor een nieuwbouwproject?',
    a: 'Dit hangt sterk af van de gewenste functionaliteiten (zoals een interactieve kaart of inschrijfmodule). Prijzen starten vanaf €2.500 voor een projectwebsite.'
  }, {
    q: 'Hoe snel kan een projectwebsite live staan?',
    a: 'Voor nieuwbouwprojecten werken we vaak met strakke deadlines rondom de start verkoop. In overleg kunnen we een website binnen 3 tot 4 weken opleveren.'
  }]} data-id="element-1080" data-mp="ho2wfnigbwfa" />;
}